export default __webpack_public_path__ + "static/2012-37dcc56409379a5d6bd2ba887467aab4.svg";